// extracted by mini-css-extract-plugin
export default {"bigBtn":"Button_bigBtn__BCPTj"};